import { render, staticRenderFns } from "./TaskUpdatedWidget.vue?vue&type=template&id=1bb9dda0&scoped=true&"
import script from "./TaskUpdatedWidget.vue?vue&type=script&lang=js&"
export * from "./TaskUpdatedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb9dda0",
  null
  
)

export default component.exports